import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class QueryService {
  private whichTabs = new BehaviorSubject<string>('MY');
  private whichTab$ = this.whichTabs.asObservable();

  setTabs(tabs: string) {
    this.whichTabs.next(tabs);
  }

  getTabs(): Observable<string>{
    return this.whichTab$;
  }
  constructor(private http: HttpClient) {}

  isRhr(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/helpdesk/get_rhr`);
  }

  getCategory(status: any = ''): Observable<any> {
    let param = new HttpParams();
    if (status !== '') {
      param = param.append('status', '1');
    }

    return this.http.get(
      `${environment.apiUrl}/helpdesk/query-category/get_category`,
      { params: param }
    );
  }

  editCategoryStatus(stat, catID): Observable<any> {
    const option = {
      status: stat,
      cat_id: catID,
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/helpdesk/query-category/edit_category_status_action`,
      options
    );
  }

  editCategory(catID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/query-category/edit_category/` + catID
    );
  }

  getMannualActionPermission(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/helpdesk/manual_action_permission`);
  }

  deleteCategory(catID): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/helpdesk/query-category/delete_category`,
      { cat_id: catID }
    );
  }

  addCategory(data: FormData, editID): Observable<any> {
    if (!editID) {
      return this.http.post<any>(
        `${environment.apiUrl}/helpdesk/query-category/add_category`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/helpdesk/query-category/edit_category_action`,
        data
      );
    }
  }

  // SubCategory

  getSubCategory(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get(
      `${environment.apiUrl}/helpdesk/query-category/get_sub_category`,
      { params: param }
    );
  }
  getSubCategoryExEmp(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get(
      `${environment.apiUrl}/helpdesk/query-category/get_sub_category_ex_emp`,
      { params: param }
    );
  }

  editSubCategoryStatus(stat, subCatID): Observable<any> {
    const option = {
      status: stat,
      subcat1_id: subCatID,
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/helpdesk/query-category/edit_sub_category_status_action`,
      options
    );
  }

  editSubCategory(subCatID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/query-category/edit_sub_category/` +
        subCatID
    );
  }

  deleteSubCategory(subCatID): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/helpdesk/query-category/delete_sub_category`,
      { subcat1_id: subCatID }
    );
  }

  addSubCategory(data: FormData, editID): Observable<any> {
    if (!editID) {
      return this.http.post<any>(
        `${environment.apiUrl}/helpdesk/query-category/add_sub_category`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/helpdesk/query-category/edit_sub_category_action`,
        data
      );
    }
  }

  // Child

  getChildCategory(): Observable<any> {
    return this.http.get(
      `${environment.apiUrl}/helpdesk/query-category/get_sub_child_category`
    );
  }

  editChildCategoryStatus(stat, subCatID): Observable<any> {
    const option = {
      status: stat,
      subcat2_id: subCatID,
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/helpdesk/query-category/edit_sub_child_category_status_action`,
      options
    );
  }

  editChildCategory(subCatID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/query-category/edit_sub_child_category/` +
        subCatID
    );
  }

  deleteChildCategory(subCatID): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/helpdesk/query-category/delete_sub_child_category`,
      { subcat2_id: subCatID }
    );
  }

  addChildCategory(data: FormData, editID): Observable<any> {
    if (!editID) {
      return this.http.post<any>(
        `${environment.apiUrl}/helpdesk/query-category/add_sub_child_category`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/helpdesk/add_qry`,
        data
      );
    }
  }

  // create query

  // getEmployees(): Observable<any[]> {
  //   return this.http.get<any[]>(`${environment.apiUrl}/employee/get_employee`);
  // }

  getEmployeeDetails(id): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/get_emp_details`,
      { user_id: id }
    );
  }

  getSub2Category(catID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/query-category/select_subchild_category/` +
        catID
    );
  }

  AddQuery(data): Observable<any[]> {
    return this.http.post<any>(`${environment.apiUrl}/helpdesk/add_qry`, data);
  }

  addQueryBulkExcel(data): Observable<any[]> {
    return this.http.post<any>(
      `${environment.apiUrl}/helpdesk/add_qry_bulk_excel`,
      data
    );
  }

  getSpecificQuery(queryId): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/query-category/select_subchild_category/` +
        queryId
    );
  }

  getQueryMaster(): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/get_query_master`
    );
  }

  getMyQueryMaster(data): Observable<any> {
    console.log(data);
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(`${environment.apiUrl}/helpdesk/get_my_query`, {
      params: param,
    });
  }

  getReportiesQueryMaster(data): Observable<any> {
    console.log(data);
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/get_reporties_query`,
      { params: param }
    );
  }

  getAssignQueryMaster(data): Observable<any> {
    console.log(data);
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/get_assign_query`,
      { params: param }
    );
  }

  getMySpecificQuery(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(`${environment.apiUrl}/helpdesk/specificQuery`, {
      params: param,
    });
  }

  getQueryStatus(): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/get_query_status`
    );
  }

  addQueryTransaction(formData): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/helpdesk/addQueryTxn`,
      formData
    );
  }

  getQueryTransaction(id): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/getQueryTxn/${id}`
    );
  }
  addFinance(data: FormData): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/helpdesk/update_finance_action`,
      data
    );
  }
  addMobile(data: FormData): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/helpdesk/update_mobile_action`,
      data
    );
  }
  addEmpQryData(data: FormData): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/helpdesk/update_emp_qry_data`,
      data
    );
  }

  updateQuerySubcate(formData): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/helpdesk/updateSubCate`,
      formData
    );
  }

  addQueryCommunication(formData): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/helpdesk/addQueryComm`,
      formData
    );
  }

  getEmployeeQryDetail(id): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/get_employee_qry_details/` + id
    );
  }

  addQualification(data: FormData): Observable<any[]> {
    return this.http.post<any>(
      `${environment.apiUrl}/helpdesk/update_qual_data`,
      data
    );
  }
  addEmpSource(data: FormData): Observable<any[]> {
    return this.http.post<any>(
      `${environment.apiUrl}/helpdesk/update_employee_source`,
      data
    );
  }
  addEmpJoiningKit(data: FormData): Observable<any[]> {
    return this.http.post<any>(
      `${environment.apiUrl}/helpdesk/update_employee_joining_kit`,
      data
    );
  }

  userBasicDetails(data: FormData): Observable<any[]> {
    return this.http.post<any>(
      `${environment.apiUrl}/helpdesk/update_basic_details`,
      data
    );
  }

  getQueryTeam(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/setups/teams/query_team`);
  }

  assignQuery(data: FormData): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/helpdesk/assign_query`,
      data
    );
  }

  reopenQuery(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/helpdesk/reopen_query`,
      data
    );
  }

  queryUserDetails(queryId): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/userDetails/${queryId}`
    );
  }

  queryCreatorEmp(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/helpdesk/queryCreatorEmp`);
  }

  addEmail(data: FormData): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/helpdesk/update_email_action`,
      data
    );
  }

  getIvrsWpd(): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/ivr/ivrsWpd`);
  }

  getAssignWPDQueryMaster(data): Observable<any> {
    console.log(data);
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(`${environment.apiUrl}/ivr/ivrsWpdMaster`, {
      params: param,
    });
  }

  getJobLocation(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/ivr/jobLocation`);
  }

  getJobRole(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/ivr/jobRole`);
  }

  changeSettingWpd(data): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/ivr/changeSetting`, data);
  }

  getWpdStages(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/ivr/wpdStatus`);
  }

  submitWpdTrans(data): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/ivr/wpdTrans`, data);
  }

  getWPDLogs(id): Observable<any> {
    let param = new HttpParams();
    param = param.append('qryId', id);
    return this.http.get<any>(`${environment.apiUrl}/ivr/wpdLogs`, {
      params: param,
    });
  }

  // ivr wpd mapping

  getivrlang(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/ivr/get_ivr_lang`);
  }

  getMappedWpd(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/ivr/get_ivr_wpd`);
  }

  editMappedWpd(ID): Observable<any> {
    return this.http.get(`${environment.apiUrl}/ivr/edit_ivr_wpd/${ID}`);
  }

  statusUpdateWpd(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/ivr/edit_ivr_wpd_status`,
      data
    );
  }

  deleteWpdmapping(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/ivr/delete_ivr_wpd`,
      data
    );
  }

  getivrsWpdCat(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/ivr/ivrsWpd`);
  }

  addIvrWpdMapping(data): Observable<any> {
    if (!data.id) {
      return this.http.post<any>(
        `${environment.apiUrl}/ivr/add_wpd_action`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/ivr/edit_ivr_wpd_action`,
        data
      );
    }
  }

  // update user in nquery

  updateEmpQuery(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/helpdesk/update_pc_mob_in_qry`,
      data
    );
  }

  rejectFinance(data: FormData): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/helpdesk/reject_finance_action`,
      data
    );
  }

  rejectBasicData(data: FormData): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/helpdesk/reject_basic_action`,
      data
    );
  }

  getWPDQueryMasterExcel(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/ivr/selfIvrsWpdMasterExcel`,
      data
    );
  }
  uploadAnonymsQryFromTempExcel(data): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/helpdesk/report/upload_anonymsQryfrom_temp_excel`,data);
  }

  uploadManualQryFromTempExcel(data): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/helpdesk/report/upload_manualQryfrom_temp_excel`,data);
  }

  exportAnonymsQuery(): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/report/downloadAnonymsQuery`,
    );
  }

  replaceUserWPD(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/ivr/replaceUserWpd`,
      data
    );
  }
}
